<template>
  <Transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <div v-if="isOpen" :class="containerStyles">
      <nav-link
        v-for="link in links"
        :ctaLabel="link.name"
        :ctaLink="link.url"
      />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed, onMounted, toRefs, ref } from "vue";
import NavLink from "@organisms/Navigation/NavLink.vue";
import { INavLink } from "@/types/components/INavigationProps";

const props = defineProps<{
  links?: INavLink[];
  isOpen: boolean;
  classes?: string;
}>();
const { links, isOpen, classes } = toRefs(props);
const isMobile = ref(false);

onMounted(() => {
  isMobile.value = window.innerWidth < 1024;
});

function beforeEnter(el: Element) {
  if (!(el instanceof HTMLElement)) return;
  el.style.maxHeight = "0";
  el.style.opacity = "0";
  if (isMobile.value) {
    el.style.transform = "translateY(-10px)";
  } else {
    el.style.transform = "translateX(-30px)";
  }
}

function enter(el: Element, done: () => void) {
  if (!(el instanceof HTMLElement)) return;
  const height = el.scrollHeight + 24;
  el.style.transition =
    "max-height 0.5s ease-in-out, opacity 0.5s ease-in-out 0.15s, transform 0.5s ease-in-out 0.1s";
  el.style.maxHeight = height + "px";
  el.style.opacity = "1";
  if (isMobile.value) {
    el.style.transform = "translateY(0)";
  } else {
    el.style.transform = "translateX(0)";
  }
  done();
}

function leave(el: Element) {
  if (!(el instanceof HTMLElement)) return;
  const height = el.scrollHeight + 24;
  el.style.maxHeight = height + "px";
  // Force reflow, necessary to ensure the transition starts from the current max-height
  void el.offsetHeight;
  el.style.maxHeight = "0";
  el.style.opacity = "0";
  if (isMobile.value) {
    el.style.transform = "translateY(-10px)";
  } else {
    el.style.transform = "translateX(-30px)";
  }
  el.style.transition =
    "max-height 0.5s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out";
}

const containerStyles = computed(() => {
  return `h-auto mx-6 transition flex flex-col ${classes?.value} subNavLinkContainer`;
});
</script>
